export default __webpack_public_path__ + "static/media/icon-drone.61d89513.webp";